import Flex from "@irati/ui/src/Flex"
import React, {useState} from "react"
import styled, {css} from "styled-components"
import {StyledSortBy} from "@irati-web/perks/src/containers/Deals/styled"
import {IconTypes} from "@irati/ui/src/Icon"
import History from "@irati/utils/history"
import qs from "qs"
import {useIntl} from "@irati/utils/lang"

interface BrochureGroupsType {
  id: string
  term: string
}

export enum SortOption {
  POPULARITY = "popularity",
  NEWEST = "newest",
  PRICE_DESC = "price_desc",
  PRICE_ASC = "price_asc",
  NAME_ASC = "name_asc",
  NAME_DESC = "name_desc"
}

const sortOptions = [
  {value: SortOption.POPULARITY, label: "platform.payrollpay.store.sort.popularity.label"},
  {value: SortOption.NEWEST, label: "platform.payrollpay.store.sort.newest.label"},
  {value: SortOption.PRICE_DESC, label: "platform.payrollpay.store.sort.priceDesc.label"},
  {value: SortOption.PRICE_ASC, label: "platform.payrollpay.store.sort.priceAsc.label"},
  {value: SortOption.NAME_ASC, label: "platform.payrollpay.store.sort.nameAsc.label"},
  {value: SortOption.NAME_DESC, label: "platform.payrollpay.store.sort.nameDesc.label"}
]

export const FilterDropDown: React.FC<{brochureGroups: BrochureGroupsType[]}> = ({brochureGroups}) => {
  const {formatMessage} = useIntl()

  const defaultBrochureGroup = (groups: BrochureGroupsType[]) => {
    return groups.filter((bg) => Number(bg.term) < 36).slice(-1)[0]?.id || groups.slice(-1)[0]?.id
  }

  const brochureGroupsOptions = brochureGroups.map(({id, term}) => ({
    value: id,
    label: term + " " + formatMessage({id: "platform.payrollpay.store.sort.monthTerm"})
  }))

  const urlParams = new URLSearchParams(window.location.search)
  const bgFromUrl = urlParams.get("bg")
  const sortFromUrl = urlParams.get("sort_by")
  const [selectedBrochureGroup, setSelectedBrochureGroup] = useState(bgFromUrl || defaultBrochureGroup(brochureGroups))
  const [selectedSort, setSelectedSort] = useState<SortOption>((sortFromUrl as SortOption) || SortOption.POPULARITY)

  const updateSearchParams = (changes: {[key: string]: string}) => {
    const currentQuery = qs.parse(location.search.replace("?", ""))
    const newQuery = {...currentQuery, ...changes}
    const search = qs.stringify(newQuery)

    History.push({pathname: location.pathname, search})
  }

  return (
    <Container marginBottom={2} justifyContent="flex-end" padding="0 16px" gap="8px">
      {selectedBrochureGroup && brochureGroups.length > 1 && (
        <StyledSortBy
          icon={IconTypes.calendar}
          options={brochureGroupsOptions}
          value={selectedBrochureGroup}
          onClick={(option) => {
            setSelectedBrochureGroup(option.value)
            updateSearchParams({bg: option.value})
          }}
          small
        />
      )}
      <StyledSortBy
        icon={IconTypes.filter3}
        options={sortOptions}
        value={selectedSort}
        onClick={(option) => {
          setSelectedSort(option.value)
          updateSearchParams({sort_by: option.value})
        }}
        small
      />
    </Container>
  )
}

const Container = styled(Flex)`
  ${({theme}) => css`
    flex-direction: column;
    ${theme.mediaQueries.minWidthMedia.desktop`
      flex-direction: row;
    `}
  `}
`
